











































































































































































import Vue from 'vue'
import { columns } from './components/data'
import { getCurrentPage, isDisplayShow } from '@/utils'
import AdvancedSearch from '@/components/AdvancedSearch'
import AppSelect from '../../../../components/AppSelect/index.vue'
import CreateOrEditModal from './components/CreateOrEditModal.vue'
import ImportProductModal from './components/ImportProductModal.vue'
import TabPanel from './components/TabPanel.vue'
import BomQingdan from './components/BomQingdan.vue'
import QualityTesting from './components/QualityTesting/QualityTesting.vue'
import Import from './components/Import.vue'
import CodeModel from '@/components/CodeModel/index.vue'
import { exportProductPOST, exportProductTemplateGET, importProductsPOST } from '@/api/api'
import {
  ProductTypeServiceProxy,
  ProductServiceProxy,
  ProductSearchDTO
} from '@/service-proxies/app-v2/product.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import SelectMaterial from './components/SelectMaterial.vue'
import { getLocalStorage, setLocalStorage } from '@/utils/storage'

const productTypeServiceProxy = new ProductTypeServiceProxy()
const productServiceProxy = new ProductServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
export default Vue.extend({
  name: 'Product',
  components: {
    AdvancedSearch,
    AppSelect,
    CreateOrEditModal,
    ImportProductModal,
    TabPanel,
    BomQingdan,
    SelectMaterial,
    Import,
    CodeModel,
    QualityTesting
  },
  data() {
    return {
      keyWords: '', // 关键词查询
      createModalVisible: false,
      loading: false,
      pagination: {
        total: 0,
        pageSize: 15,
        current: 1
        // showTotal: (total) => '共0条'
      },
      selectedRowKeys: [],
      typeList: [], // 产品类型列表
      typeListObj: {},
      typeId: '',
      advancedQuery: false, // 是否为高级查询
      productList: [],
      modalType: 'add', // 模态框是新增还是编辑
      editItem: {},
      importProductVisible: false,
      tabs: [],
      productId: '', // 选中的产品
      productColums: [], // 产品表格的字段
      showColumns: [],
      tableScrollWidth: 1700,
      selectedRowIndex: 0,
      resizeTimer: null,
      tableScrollY: 300,
      isRefreshCraft: true,
      selectProducts: [],
      selectMaterialVisible: false,
      printVisible: false,
      dataList: [], //打印列表
      defalutTab: 0
    }
  },
  computed: {
    productCode() {
      const product = this.productList.find((item) => item.id == this.productId) || {}
      return product.code
    },
    columns() {
      return columns.map((item: any) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    downloadFn() {
      return this.exportProductTemplateGET
    }
  },
  created() {
    this.tabs = [this.$t('page_product_process_path'), 'BOM清单', '质检']
    const isQuality = getLocalStorage('Quality')
    if (isQuality === 'quality') {
      this.defalutTab = 2
      setLocalStorage('Quality', '')
    }
    this.getProductTypeList()
  },
  // watch: {
  //   pagination: {
  //     handler(val) {
  //       console.log(8888,val)
  //       this.pagination.showTotal = (total) => {
  //         return this.$t('Total…items').replace('{0}', ` ${val.total} `)
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
    },
    handleImportProduct(file, fixedEdition) {
      return new Promise(async (resolve) => {
        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('typeId', this.typeId)
        formData.append('fixedEdition', fixedEdition)
        const res = await importProductsPOST(formData)
        resolve(res)
      })
    },
    exportProductTemplateGET() {
      return new Promise(async (resolve) => {
        const res = await exportProductTemplateGET(this.typeId)
        resolve(res)
      })
    },
    // 获取指定业务的字段列表
    async getTableColumn() {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField(
        'product',
        this.typeId
      )
      // console.log('productColums:', this.productColums)
      this.handleColumns()
    },
    pagenitionChange(currentPage) {
      this.pagination.current = currentPage
      this.getProductList()
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = []
      this.productColums.map((item) => {
        if (isDisplayShow(item.isDisplay, 2)) {
          // 自定义字段：产品类型
          switch (item.code) {
            case 'typeId':
              columns.push({
                title: item.title,
                dataIndex: item.code,
                ellipsis: true,
                scopedSlots: { customRender: 'productType' },
                key: item.code
              })
              break
            case 'supplier':
            case 'replaceSupplier':
            case 'replaceCodes':
              columns.push({
                title: item.title,
                dataIndex: item.code,
                ellipsis: true,
                key: item.code
              })
              break
            default:
              columns.push({
                title: item.title,
                key: item.code,
                dataIndex: item.code,
                ellipsis: true
              })
          }
        }
      })
      this.showColumns = [
        {
          title: this.$t('page_tenant_operation'),
          key: 'action',
          width: 80,
          scopedSlots: { customRender: 'action' }
        },
        ...columns
      ]
      let num = this.productColums.filter((item) => isDisplayShow(item.isDisplay, 2)).length
      if (num > 17) {
        this.tableScrollWidth = num * 100
      }
    },
    getProductTypeList() {
      this.typeList = []
      this.typeListObj = {}
      productTypeServiceProxy.getPageProductTypes(1, '', '', 9999, 2).then((res: any) => {
        let list = res.records
        list.map((type: any) => {
          this.typeList.push({ label: type.name, value: type.id })
          this.typeListObj[type.id] = type.name
        })
        this.typeId = this.typeList.length ? this.typeList[0].value : ''
        this.getTableColumn()
        this.getProductList()
      })
    },
    getProductList(reload?: boolean, selectedInit?: boolean, params = {}) {
      if (reload) {
        // 从头加载
        this.pagination.current = 1
      }
      this.productList = []
      // this.selectedRowKeys = []
      if (!this.typeId) {
        return
      }
      let param = new ProductSearchDTO({
        filterPlus: !!Object.getOwnPropertyNames(params).length,
        keyWords: this.keyWords,
        param: params, // 高级查询字段map
        typeId: this.typeId
      })
      this.loading = true
      productServiceProxy
        .getPageProducts(this.pagination.current, param, this.pagination.pageSize)
        .then((res: any) => {
          this.pagination.total = Number(res.total)
          this.productList = res.records
          if (this.productList.length) {
            // 保持此前的选中行，若没有此前的选中行，则默认选中第一行
            if (!this.productList.find((item) => item.id === this.productId) || selectedInit) {
              this.productId = this.productList[0].id
              this.selectedRowIndex = (this.pagination.current - 1) * this.pagination.pageSize
              // 默认勾选第一行的复选框
              this.selectedRowKeys = []
              this.selectedRowKeys.push(this.productList[0].id)
            }
          } else {
            this.productId = ''
            this.selectedRowIndex = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 切换产品类型
    handleTypeChange(e: any) {
      this.typeId = e
      this.getTableColumn()
      this.getProductList(true)
    },
    // 分页改变
    handleTableChange(pagination, filters, sorter) {
      const pager = {
        pageSize: pagination.pageSize,
        current: pagination.current
      }
      Object.assign(this.pagination, pager)
      this.getProductList()
    },
    // 表格勾选
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      // console.log(selectedRowKeys)
    },
    // 打开产品新增或编辑弹框
    openModal(type?: string, record?: any) {
      this.modalType = type ? type : 'add'
      this.createModalVisible = true
      if (record) {
        this.editItem = record
      }
    },
    // 关闭产品新增或编辑弹框
    closeProductModal(data) {
      // reload：重新加载列表数据，selectedInit：是否重置选中行
      const { reload, selectedInit } = data
      this.createModalVisible = false
      if (reload) {
        this.getProductList(reload, selectedInit)
      }
    },
    // 导出类型选择
    handleMenuClick({ key }) {
      if (key === '1') {
        // 选中导出
        this.exportProduct(1)
      } else {
        // 筛选结果导出
        this.exportProduct()
      }
    },
    // 批量删除产品
    deleteProduct() {
      this.$confirm({
        title: this.$t('page_product_confirm_delete_product_checked'),
        // content: this.$t('delete_directory_group_confirm_content'),
        okText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          return new Promise((resolve, reject) => {
            productServiceProxy.deleteProducts(this.selectedRowKeys).then((res: any) => {
              this.$message.success(this.$t('page_resource_pool_success'))
              this.selectedRowKeys = []
              this.selectedRowIndex = 0
              this.getProductList(true)
              resolve()
            })
          })
        }
      })
    },
    // 打开导入产品数据弹框
    importProduct() {
      this.importProductVisible = true
    },
    // 关闭产品导入弹框
    closeImportProductModal(reload: boolean) {
      this.importProductVisible = false
      if (reload) {
        this.getProductList(true)
      }
    },
    // 批量导出：支持选中导出和非选中全部导出
    exportProduct(type) {
      let params = {}
      if (type === 1) {
        if (!this.selectedRowKeys.length) {
          this.$message.error('当前未选中数据')
          return
        }
        params = {
          exportSelected: true, // 选中导出
          typeId: this.typeId,
          selectedRecords: this.selectedRowKeys
        }
      } else {
        params = {
          exportSelected: false,
          typeId: this.typeId,
          searchCondition: {
            filterPlus: false,
            keyWords: this.keyWords,
            param: {},
            typeId: this.typeId
          } // 查询条件字典map，包含高级搜索的字段
        }
      }
      exportProductPOST(params).then((res: any) => {
        var a = document.createElement('a')
        a.download = 'Product.xlsx'
        a.style.display = 'none'
        // 字符内容转变成blob地址
        let url = URL.createObjectURL(res)
        a.href = url
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },
    // 表格行点击事件
    rowClick(record: any) {
      return {
        on: {
          click: (event: any) => {
            this.selectedRowIndex =
              this.productList.findIndex((item) => item.id === record.id) +
              (this.pagination.current - 1) * this.pagination.pageSize
            // console.log(record, 'record')
            this.productId = record.id
            this.selectedRowKeys = []
            this.selectedRowKeys.push(record.id)
          }
        }
      }
    },
    scrollY() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      this.resizeTimer = setTimeout(function() {
        this.tableScrollHeight = document.querySelector('.body').clientHeight
        this.processScrollHeight = document.querySelector('.footer-container').clientHeight
        const bodyTableBody: any = document.querySelector('.body .ant-table-body')
        if (bodyTableBody) {
          bodyTableBody.style.maxHeight = this.tableScrollHeight - 88 + 'px'
          this.tableScrollY = this.tableScrollHeight - 88
        }
        const processTableBody: any = document.querySelector('.process-table .ant-table-body')
        if (processTableBody) {
          processTableBody.style.maxHeight = this.processScrollHeight - 150 + 'px'
        }
      }, 100)
    },
    // 工艺路径执行复制到其他产品后跳转到该产品下的工艺路径
    handleChange(data: any) {
      // 切换了产品类型与产品
      if (data.productTypeId) {
        this.typeId = data.productTypeId
      }
      this.isRefreshCraft = false // 是否重置工艺版本的选中状态：不重置
      this.productId = data.productId
      this.selectedRowKeys = []
      this.selectedRowKeys.push(data.productId)
      // 获取选中的product位于哪一页
      this.pagination.current = getCurrentPage(data.index, this.pagination.pageSize, data.total)
      this.getTableColumn()
      this.getProductList()
    },
    initRefreshStatus() {
      this.isRefreshCraft = true // 重置工艺版本的选中状态
    },
    syncProduct() {
      this.selectMaterialVisible = true
      this.selectProducts = this.productList.filter((res) => this.selectedRowKeys.includes(res.id))
    },
    getList() {
      this.dataList = []
      this.selectedRowKeys.map((id) => {
        this.productList.map((item) => {
          if (id === item.id) {
            this.dataList.push({
              code: item.code,
              name: item.name
            })
          }
        })
      })
    },
    printing() {
      this.getList()
      this.printVisible = true
    },
    cancel() {
      this.selectedRowKeys = []
      this.selectedRowKeys.push(this.productList[0].id)
      this.printVisible = false
    },
    handlerPrint() {
      this.selectedRowKeys = []
      this.selectedRowKeys.push(this.productList[0].id)
      this.printVisible = false
    }
  }
})
